import { render, staticRenderFns } from "./index.vue?vue&type=template&id=545c74a3&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545c74a3')) {
      api.createRecord('545c74a3', component.options)
    } else {
      api.reload('545c74a3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=545c74a3&", function () {
      api.rerender('545c74a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/index.vue"
export default component.exports